module.exports=function(scope){ return `{
    "data": {
        "glasses": false,
        "sessionTokenStatus": 0,
        "faceMapType": 0,
        "livenessStatus": 0,
        "auditTrailVerificationCheck": 0,
        "isLowQuality": false,
        "ageCheckResult": 0,
        "auditTrailMatchCheck": 0,
        "isReplayFaceMap": true
    },
    "meta": {
        "code": 200,
        "message": "The FaceMap is in the ZoOm Age Check targeted group with high confidence.",
        "ok": true,
        "m": {
            "prepareAndUpdateTimeInMS": ...,
            "checkAgeTimeInMS": ...,
            "totalDurationInMS": ...
        }
    }
}`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/age-check.json.tpl